module.exports = __webpack_public_path__ + "img/lg_ring_g_o_null_0.81e29dc7.png";